import Vue from "vue";
import Router from "vue-router";
import LoginLayout from "@/layouts/Login";
import MainLayout from "@/layouts/Main";
import Home from "@/layouts/Home";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true
      },
      children: [
        // Dashboards
        {
          path: "/dashboard",
          meta: {
            title: "Dashboard Alpha"
          },
          component: () => import("./views/dashboard/alpha")
        },
        // User
        {
          path: "/user",
          meta: {
            title: "User Manager"
          },
          component: () => import("./views/admin/user")
        },
        //debug
        {
          path: "debug",
          meta: {
            title: "Debug"
          },
          component: () => import("./views/admin/user/debug")
        },
        {
          path: "setting",
          meta: {
            title: "Setting"
          },
          component: () => import("./views/setting")
        },
        // Restaurant
        {
          path: "/restaurant",
          meta: {
            title: "Restaurant Manager"
          },
          component: () => import("./views/restaurant")
        },
        {
          path: "/restaurant/created",
          meta: {
            title: "Create Restaurant "
          },
          component: () => import("./views/restaurant/create.vue")
        },
        {
          path: "/restaurant/:id?",
          meta: {
            title: "Restaurant details"
          },
          component: () => import("./views/restaurant/detail.vue")
        },
        {
          path: "/restaurant/:id",
          meta: {
            title: "Restaurant Manager"
          },
          component: () => import("./views/restaurant/create.vue")
        },
        {
          path: "/restaurantStatistics/:id",
          meta: {
            title: "Restaurant Statistics"
          },
          component: () => import("./views/restaurant/statistics")
        },
        // Transaction
        {
          path: "/admin_transaction",
          meta: {
            title: "Transaction Manager"
          },
          component: () => import("./views/admin/transaction")
        },
        // Matched
        {
          path: "/room",
          meta: {
            title: "Room"
          },
          component: () => import("./views/admin/room")
        },
        {
          path: "/room/create",
          component: () => import("./views/admin/room/create")
        },
        {
          path: "room/:id",
          meta: {
            title: "Matched"
          },
          component: () => import("./views/admin/room/detail")
        },
        {
          path: "room/update/:id",
          meta: {
            title: "Room"
          },
          component: () => import("./views/admin/room/update")
        },
        {
          path: "statistics/:id",
          meta: {
            title: "Room statistics"
          },
          component: () => import("./views/admin/room/statistics")
        },
        {
          path: "matched/:id",
          meta: {
            title: "Matched Details"
          },
          component: () => import("./views/admin/room/matched")
        },
        // Statistics
        {
          path: "/statistics",
          meta: {
            title: "Statistics"
          },
          component: () => import("./views/admin/statistics")
        },
        {
          path: "/messenger",
          meta: {
            title: "Messenger"
          },
          component: () => import("./views/admin/room/messenger.vue")
        },
        {
          path: "/profile",
          meta: {
            title: "Profile"
          },
          component: () => import("./views/user/profile")
        },
        {
          path: "/addtran",
          meta: {
            title: "AddTransaction"
          },
          component: () => import("./views/admin/addtran")
        },
        {
          path: "addtran/:id",
          meta: {
            title: "AddTransaction details"
          },
          component: () => import("./views/admin/addtran/detail")
        },
        {
          path: "/post",
          meta: {
            title: "History"
          },
          component: () => import("./views/post")
        },
        {
          path: "/post/new",
          meta: {
            title: "New post"
          },
          component: () => import("./views/post/new")
        },
        {
          path: "/post/edit/:id?",
          meta: {
            title: "Edit post"
          },
          component: () => import("./views/post/new")
        },
        {
          path: "/post/:id?",
          meta: {
            title: "Play detail"
          },
          component: () => import("./views/post/detail")
        },
        {
          path: "/rate",
          meta: {
            title: "Rating"
          },
          component: () => import("./views/rate")
        },
        // 404
        {
          path: "/404",
          meta: {
            title: "404"
          },
          component: () => import("./views/404")
        }
      ]
    },

    {
      path: "/admin",
      component: MainLayout,
      meta: {
        authRequired: true,
        adminRequired: true,
        hidden: true
      },
      children: [
        {
          path: "user",
          meta: {
            title: "User management"
          },
          component: () => import("./views/admin/user")
        },
        {
          path: "user/:id",
          meta: {
            title: "User details"
          },
          component: () => import("./views/admin/user/detail")
        },
        {
          path: "transaction",
          meta: {
            title: "Transaction management"
          },
          component: () => import("./views/admin/transaction")
        },
        {
          path: "transaction/:id",
          meta: {
            title: "Transaction details"
          },
          component: () => import("./views/admin/transaction/detail")
        },
        {
          path: "cash/:id",
          meta: {
            title: "cash details"
          },
          component: () => import("./views/admin/transaction/detailCash")
        }
      ]
    },

    // System Pages
    {
      path: "/user",
      component: LoginLayout,
      redirect: "/user/login",
      children: [
        {
          path: "/user/login",
          meta: {
            title: "Login"
          },
          component: () => import("./views/user/login")
        },
        {
          path: "/user/forgot",
          meta: {
            title: "Forgot Password"
          },
          component: () => import("./views/user/forgot")
        }
      ]
    },

    {
      path: "/home",
      component: Home
    },


    // Redirect to 404
    {
      path: "*",
      redirect: "/404",
      hidden: true
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.user) {
      return next({
        path: "/user/login",
        query: { redirect: to.fullPath }
      });
    }
  }
  // if (to.matched.some(record => record.meta.adminRequired)) {
  //   if (!store.state.user.metadata || !store.state.user.metadata.isAdmin) {
  //     return next({
  //       path: '/dashboard'
  //     })
  //   }
  // }
  return next();
});

export default router;
